import firebase from './firebase';
import fb from 'firebase'

var db = firebase.firestore();
var auth = firebase.auth();


var config = {
    apiKey: "AIzaSyB2o9EnTc6ETFPxh_FE98eCT_AlqMCbnZU",
    authDomain: "zwerverhunt-69c09.firebaseapp.com",
    databaseURL: "https://zwerverhunt-69c09.firebaseio.com",
};
var secondaryApp = firebase.initializeApp(config, "Secondary");




export default {
    login(creds) {
        return new Promise((resolve, reject) => {
            firebase.auth().signInWithEmailAndPassword(creds.email, creds.password).then(() =>{
                resolve();
            }).catch((error) => {
                reject(error);    
            });
        });
    },
    register(user) {
        return new Promise((resolve, reject) => {
            secondaryApp.auth().createUserWithEmailAndPassword(user.email, user.password).then(function(firebaseUser) {
                secondaryApp.auth().signOut();
                db.doc('users/' + firebaseUser.uid).set({
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                    role: user.role
                })
                .then((ref)=> {
                    resolve();
                })
                .catch((error) => {
                    reject();
                });
            });
        });
    },
    init() {
        return new Promise((resolve, reject) => {
            auth.onAuthStateChanged(function(user) {
                if (user) {
                    db.doc("users/" + user.uid).get().then((doc) => {
                        var user = {};
                        user = doc.data();
                        if(user.role > 0)
                            resolve(user);
                        else
                            reject();
                    });
                } else {
                    reject();
                }
              });
        });
    },
    logout() {
        return new Promise(resolve => {
            firebase.auth().signOut().then(function() {
                resolve();
            });
        })
    }
}


// WEBPACK FOOTER //
// ./src/services/AuthService.js